export class Button {
  id: string;
  label: string;
  iconName: string;
  clickCb: () => void;
  type: string;
  disabled: boolean = false;

  constructor(
    label: string,
    iconName: string,
    clickCb: () => void,
    type: string,
    id?: string,
    disabled?: boolean,
  ) {
    this.label = label;
    this.iconName = iconName;
    this.clickCb = clickCb;
    this.id = id ?? label ?? iconName;
    this.type = type;
    this.disabled = disabled ?? false;
  }
}
